module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjYjliOWI5IiBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHRpdGxlPmJhY2t3YXJkLWxpbmU8L3RpdGxlPjxwYXRoIGQ9Ik0xNSwyMGEuNDguNDgsMCwwLDEtLjM0LS4xM2wtOC03LjVhLjUxLjUxLDAsMCwxLDAtLjc0bDgtNy41YS41LjUsMCwwLDEsLjY4Ljc0TDcuNzMsMTJsNy42MSw3LjEzYS41MS41MSwwLDAsMSwwLC43MUEuNS41LDAsMCwxLDE1LDIwWiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/backward-line-grey.svg
// module id = 92
// module chunks = 1